import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import { Feature } from "../../interfaces/feature";
import { Epic } from "../../interfaces/epic";
import { FeatureService } from "../../services/feature/feature.service";
import { environment } from "../../../environments/environment";
import { MzToastService, MzModalService } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { ProjectService } from "../../services/project/project.service";
import { isNumber } from "util";
import { ActivatedRoute } from "@angular/router";
import { AnnotationService } from "../../services/annotation/annotation.service";
import { AnnotationtypeService } from "../../services/annotationtype/annotationtype.service";
import { Annotation } from "../../interfaces/annotation";
import { Annotationvariant } from "../../interfaces/annotationvariant";
import { AnnotationvariantService } from "../../services/annotationvariant/annotationvariant.service";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { forEach } from "@angular/router/src/utils/collection";
import { PlanningPokerParticipant } from "../../interfaces/planningPokerParticipant";
import { VotingComponent } from "../voting/voting.component";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";
import { ConfirmStopVotingComponent } from "../confirm-stop-voting/confirm-stop-voting.component";

@Component({
  selector: "app-annotation-carousel",
  templateUrl: "./annotation-carousel.component.html",
  styleUrls: ["./annotation-carousel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * item carousel component to list all items as clickable slides
 */
export class AnnotationCarouselComponent implements OnChanges, OnInit {
  readonly env: any = environment;

  @Input() items: Array<Feature>;
  @Input() themes: Array<Epic>;
  @Input() itemIndex: number;
  @Input() theAnnotations: Array<Annotation>;
  @Input() theAnnotationvariants: Array<Annotationvariant>;

  @Output() carouselClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteItemClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateIndex: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("voting") voting: VotingComponent;
  @ViewChild("DeleteItemConfirmationModal")
  DeleteItemConfirmationModal: DeleteItemConfirmationDialogComponent;

  /**
   * placeholder object for chips
   * @type {any[]}
   */
  public chips: Materialize.ChipDataObject[] = [
    // { tag: 'Banana' },
    // { tag: 'Kiwi' },
    // { tag: 'Mango' },
  ];

  autocompleteOptions: Materialize.AutoCompleteOptions = {
    data: {
      // 'Andrea': null,
      // 'Vanessa': null,
      // 'Stefan': null,
      // 'Tim': null,
      // 'Erik': null,
      // 'Simon': null,
      // 'Marc': null,
      // 'Sandra': null,
    },
  };

  project: Project;
  loading: boolean = true;
  annotationtypeSelectionIsOpen: boolean = false;
  projectId: any;
  estimateLink: string;
  annotations: Array<Annotation>;
  annotationtypesArray: Array<Object>;
  annotationtypes: Object;
  allAnnotationsVariants: Array<Object>;
  theAnnotation: Annotation;
  theAnnotationVariant: Annotationvariant;
  theAnnotationVariantIndex: number;
  currentAnnotationTypeId: number;

  constructor(
    private modalService: MzModalService,
    private planningPokerService: PlanningPokerService,
    private annotationvariantService: AnnotationvariantService,
    private toastService: MzToastService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private annotationService: AnnotationService,
    private annotationtypeService: AnnotationtypeService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(async (params: { id: string }) => {
      this.loading = true;
      let project = await this.projectService.getProjectByShortId(params.id);
      this.project = project;
      this.projectId = this.project._id;
      await this.planningPokerService.watchProject(this.project.shortId);
      this.planningPokerService.participantJoined.subscribe(
        async (_) => await this.updateAutocompleteData()
      );
      this.estimateLink =
        this.env.agirUrl + "/planning-poker/" + this.project.shortId;
      let annotations = await this.annotationService.getAnnotationsByProjectId(
        this.project._id
      );
      this.annotations = this.getSortedArray(annotations);
      this.allAnnotationsVariants = this.flattenAnnotations(this.annotations);

      await this.initAnnotationTypes();

      await this.updateAutocompleteData();
      this.loading = false;
    });
  }

  /**
   * Initializes the available annotation types for this project.
   */
  private async initAnnotationTypes() {
    // Retrieve all available annotation types as JSON object
    // and properly map its properties (= the annotation types) onto an array.
    // Each object has two properties that are relevant in this context: "name" and "label".
    // "Name" is the internal name of the annotation type and "label" is its display name.
    let tmp = await this.annotationtypeService.getAnnotationtypesByVersion(
      this.project.version
    );
    let annotationTypeObjects = Object.keys(tmp).map((e) => tmp[e]);

    this.annotationtypesArray = new Array<Object>();
    this.annotationtypes = new Object();

    annotationTypeObjects.forEach((annotationType) => {
      this.annotationtypesArray.push(annotationType);
      this.annotationtypes[annotationType["name"]] = annotationType;
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["itemIndex"]) {
      if (this.itemIndex > -1 && this.theAnnotations) {
        this.allAnnotationsVariants = this.flattenAnnotations(
          this.theAnnotations
        );
        await this.setAnnotationAndVariantFromItemIndex();
        // this.effort = '-'; //this.theAnnotations[this.itemIndex].effort || '-';
        //if(this.items[this.itemIndex].effort === 0) this.effort = 0;
      }
    }
  }

  getMedian() {
    if (this.theAnnotationVariant.estimations.length === 0) return "-";
    else
      return this.theAnnotationVariant.estimations[
        this.theAnnotationVariant.estimations.length - 1
      ].median;
  }

  async updateAutocompleteData() {
    let existingStakeholders = await this.projectService.getStakeholders(
      this.projectId
    );
    let participants = Array.from(
      this.planningPokerService.participants.values()
    ).map((x) => x.name);
    let stakeholders = existingStakeholders.concat(participants);
    for (var variableKey in this.autocompleteOptions.data) {
      if (this.autocompleteOptions.data.hasOwnProperty(variableKey)) {
        delete this.autocompleteOptions.data[variableKey];
      }
    }
    for (let stakeholder of stakeholders
      .filter((x, i) => stakeholders.indexOf(x) === i)
      .sort((x, y) => (x < y ? -1 : x > y ? 1 : 0))) {
      this.autocompleteOptions.data[stakeholder] = null;
    }
  }

  async setAnnotationAndVariantFromItemIndex() {
    /*
    fill autocomplete options with current Stakeholders
     */
    this.chips = [];
    var r = 0;

    outerloop: for (var i = 0; i < this.theAnnotations.length; ++i) {
      this.theAnnotation = this.theAnnotations[i];
      for (var j = 0; j < this.theAnnotation.variants.length; ++j) {
        if (this.itemIndex === r) {
          this.theAnnotationVariant = this.theAnnotation.variants[j];
          this.theAnnotationVariantIndex = j;
          // this.chips = this.theAnnotationVariant.stakeholder;
          for (
            let k = 0;
            k < this.theAnnotationVariant.stakeholder.length;
            k++
          ) {
            this.chips.push({ tag: this.theAnnotationVariant.stakeholder[k] });
          }
          break outerloop;
        }
        r = r + 1;
      }
    }

    await this.updateAutocompleteData();
  }

  flattenAnnotations(annotations: Array<Annotation>) {
    var r = [];
    annotations.forEach((annotation) => {
      annotation.variants.forEach((variant, idx) => {
        r.push({
          number: annotation.number,
          variantNumber: idx,
          stakeholder: variant.stakeholder,
          description: variant.description,
        });
      });
    });
    return r;
  }

  async saveAnnotation(annotation) {
    await this.annotationService.updateAnnotation(annotation);
    this.indexUpdate();
  }

  async saveAnnotationVariant(annotationVariant) {
    await this.annotationvariantService.updateAnnotationvariant(
      annotationVariant
    );
    this.indexUpdate();
  }

  deleteItem() {
    this.deleteItemClicked.emit(this.items[this.itemIndex]);
  }

  closeCarousel() {
    this.carouselClosed.emit();
    this.itemIndex = -1;
    // this.consenseClicked = false;
  }

  indexUpdate() {
    this.updateIndex.emit();
  }

  private getSortedArray(annotations) {
    return annotations.sort(
      (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
  }

  openSelection(id) {
    this.annotationtypeSelectionIsOpen = true;
    this.currentAnnotationTypeId = id;
  }

  closeSelection() {
    this.annotationtypeSelectionIsOpen = false;
  }

  async addAnnotationtype(annotationtype) {
    this.loading = true;

    if (this.currentAnnotationTypeId !== undefined) {
      this.theAnnotation.types[this.currentAnnotationTypeId] =
        annotationtype.name;
    } else {
      this.theAnnotation.types.push(annotationtype.name);
    }

    await this.annotationService.updateAnnotation(this.theAnnotation);
    let annotations = await this.annotationService.getAnnotationsByProjectId(
      this.project._id
    );
    this.theAnnotations = this.getSortedArray(annotations);
    this.allAnnotationsVariants = this.flattenAnnotations(this.theAnnotations);
    this.itemIndex = this.getItemIndex(this.theAnnotationVariant);
    this.indexUpdate();
    await this.setAnnotationAndVariantFromItemIndex();
    this.loading = false;
    this.annotationtypeSelectionIsOpen = false;
  }

  async deleteAnnotationType(index) {
    this.loading = true;

    if (
      index !== undefined &&
      index >= 0 &&
      index < this.theAnnotation.types.length
    ) {
      this.theAnnotation.types.splice(index, 1);
      await this.annotationService.updateAnnotation(this.theAnnotation);
      let annotations = await this.annotationService.getAnnotationsByProjectId(
        this.project._id
      );
      this.theAnnotations = this.getSortedArray(annotations);
      this.allAnnotationsVariants = this.flattenAnnotations(
        this.theAnnotations
      );
      this.itemIndex = this.getItemIndex(this.theAnnotationVariant);
      this.indexUpdate();
      await this.setAnnotationAndVariantFromItemIndex();
    }

    this.loading = false;
  }

  changeAnnotationType(index) {
    this.openSelection(index);
  }

  /**
   * closing carousel if clicking outside modal window
   * @param event
   */
  async close(event) {
    if (event.target.id === "itemCarouselModal") {
      if (this.voting && this.voting.isCurrentlyVoting()) {
        var confirm = await (<ConfirmStopVotingComponent>(
          this.modalService.open(ConfirmStopVotingComponent).instance
        )).result
          .asObservable()
          .first()
          .toPromise();
        if (!confirm) return;
        await this.voting.stopVoting();
      }
      this.closeCarousel();
    }
  }

  async updateSlidesNext() {
    if (this.voting && this.voting.isCurrentlyVoting()) {
      var confirm = await (<ConfirmStopVotingComponent>(
        this.modalService.open(ConfirmStopVotingComponent).instance
      )).result
        .asObservable()
        .first()
        .toPromise();
      if (!confirm) return;
      await this.voting.stopVoting();
    }
    if (this.itemIndex < this.allAnnotationsVariants.length - 1) {
      this.itemIndex++;
      await this.setAnnotationAndVariantFromItemIndex();
    }
  }

  async updateSlidesPrev() {
    if (this.voting && this.voting.isCurrentlyVoting()) {
      var confirm = await (<ConfirmStopVotingComponent>(
        this.modalService.open(ConfirmStopVotingComponent).instance
      )).result
        .asObservable()
        .first()
        .toPromise();
      if (!confirm) return;
      await this.voting.stopVoting();
    }
    if (this.itemIndex > 0) {
      this.itemIndex--;
      await this.setAnnotationAndVariantFromItemIndex();
    }
  }

  toastCopyToClipboard() {
    this.toastService.show(
      "Link wurde in die Zwischenablage kopiert!",
      4000,
      "confirm-toast"
    );
  }

  /**
   * set estimate-password value and if its required
   */
  setEstimatePassword() {
    this.projectService
      .setEstimatePassword(this.project)
      .then(() => {
        this.toastService.show("Gespeichert!", 4000, "confirm-toast");
      })
      .catch((res) => {
        this.toastService.show(
          "Fehler! Nicht Gespeichert",
          4000,
          "notification-toast"
        );
      });
  }

  getItemIndex(variant: Annotationvariant) {
    let index = 0;
    for (let i = 0; i < this.theAnnotations.length; ++i) {
      let annotation = this.theAnnotations[i];
      for (let j = 0; j < annotation.variants.length; ++j) {
        if (variant._id === annotation.variants[j]._id) {
          // this.theAnnotationVariant = this.theAnnotation.variants[j];
          // this.theAnnoatationVariantIndex = j;
          return index;
        }
        index++;
      }
    }
  }

  createVariant() {
    this.loading = true;
    const lastVariant = this.theAnnotation.variants[
      this.theAnnotation.variants.length - 1
    ];
    this.annotationvariantService
      .createAnnotationvariant({
        projectId: this.project._id,
        annotationId: this.theAnnotation._id,
        description:
          lastVariant.description /*stakeholder: lastVariant.stakeholder,*/,
      })
      .then((variant: Annotationvariant) => {
        this.loading = false;
        this.annotationService
          .getAnnotationsByProjectId(this.project._id)
          .then(async (annotations: Array<Annotation>) => {
            this.theAnnotations = this.getSortedArray(annotations);
            this.allAnnotationsVariants = this.flattenAnnotations(
              this.theAnnotations
            );
            this.itemIndex = this.getItemIndex(variant);
            this.indexUpdate();
            await this.setAnnotationAndVariantFromItemIndex();
          });
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  }

  createAnnotation() {
    this.loading = true;
    this.annotationService
      .createAnnotation({ projectId: this.project._id })
      .then(async (annotation: Annotation) => {
        this.theAnnotations.push(annotation);
        this.indexUpdate();
        this.allAnnotationsVariants = this.flattenAnnotations(
          this.theAnnotations
        );
        this.itemIndex = this.allAnnotationsVariants.length - 1;
        await this.setAnnotationAndVariantFromItemIndex();
        this.loading = false;
      });
  }

  deleteAnnotation() {
    this.loading = true;
    this.annotationService
      .deleteAnnotationById(this.theAnnotation._id)
      .then(() => {
        // this.router.navigate(['/annotations/' + this.project.shortId]);
        this.annotationService
          .getAnnotationsByProjectId(this.project._id)
          .then(async (annotations: Array<Annotation>) => {
            this.theAnnotations = this.getSortedArray(annotations);
            this.allAnnotationsVariants = this.flattenAnnotations(
              this.theAnnotations
            );
            // this.itemIndex = this.getItemIndex(variant);
            if (this.itemIndex - 1 !== -1) {
              this.itemIndex--;
            }
            this.indexUpdate();
            await this.setAnnotationAndVariantFromItemIndex();
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
        // this.indexUpdate();
        // if(this.itemIndex === this.)
        // this.setAnnotationAndVariantFromItemIndex();
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  async deleteVariant(variantIndexToDelete) {
    let result = await this.DeleteItemConfirmationModal.getResultAsync();
    if (result === true) {
      this.loading = true;
      if (variantIndexToDelete === 0 || variantIndexToDelete) {
        this.loading = true;
        if (this.theAnnotation.variants.length === 1) {
          // console.log("aufgerufen");
          this.deleteAnnotation();
        } else {
          const variant = this.theAnnotation.variants[variantIndexToDelete];
          this.annotationvariantService
            .deleteAnnotationvariantById(variant._id)
            .then(async () => {
              this.theAnnotation.variants.splice(variantIndexToDelete, 1);
              variantIndexToDelete = null;
              if (this.itemIndex - 1 !== -1) {
                this.itemIndex--;
              }
              this.indexUpdate();
              await this.setAnnotationAndVariantFromItemIndex();
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              variantIndexToDelete = null;
            });
        }
      }
    }
    this.loading = false;
  }

  onAdd(event) {
    // this.theAnnotationVariant.stakeholder = this.chips;
    if (this.theAnnotationVariant.stakeholder.indexOf(event.tag) === -1) {
      this.theAnnotationVariant.stakeholder.push(event.tag);
      this.annotationvariantService
        .updateAnnotationvariant(this.theAnnotationVariant)
        .then((_) => {
          // console.log("yyyyaaaaayyy");
        })
        .catch((error) => {
          console.log(error);
        });
      this.indexUpdate();
    }
  }

  onDelete(event) {
    if (this.theAnnotationVariant.stakeholder.indexOf(event.tag) !== -1) {
      let stakeholderToDelete = this.theAnnotationVariant.stakeholder.indexOf(
        event.tag
      );
      this.theAnnotationVariant.stakeholder.splice(stakeholderToDelete, 1);
      this.annotationvariantService
        .updateAnnotationvariant(this.theAnnotationVariant)
        .then((_) => {
          // console.log("yyyyaaaaayyy");
        })
        .catch((error) => {
          console.log(error);
        });
      this.indexUpdate();
    }
  }

  async onVotingChanges() {
    await this.annotationvariantService.updateAnnotationvariant(
      this.theAnnotationVariant
    );
    this.indexUpdate();
  }

  async onKeyDown(event) {
    if (event.key === "ArrowRight") {
      await this.updateSlidesNext();
    }
    if (event.key === "ArrowLeft") {
      await this.updateSlidesPrev();
    }
    // console.log(event.key);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotation-carousel/annotation-carousel.component.ts